/**
 * Creates a product in basket map in order to do client side checks for products which are in basket.
 */
class ProductQtyMap {
    constructor() {
        const currentBasketElement = document.querySelectorAll("[data-productqtymap]");

        try {
            const productQtyMap = JSON.parse(currentBasketElement[0].dataset.productqtymap);
            this.items = productQtyMap.items;
        } catch  {
            this.items = [];
        }
    }
    /**
     * Updates the items in the map in order to keep track of basket updates;
     * @param {Array} items 
     */
    refreshItems(items) {
        this.items = [...items];
    }
}

/**
 * Retruns new instance of ProductQtyMap;
 */
const getNewProductQtyMap = () => {
    return new ProductQtyMap();
};


const productMap = new ProductQtyMap();

export { productMap as default, getNewProductQtyMap };

